export enum DirectionTypeEnum {
  AMOUNT = 'AMOUNT',
  PERCENT = 'PERCENT',
  CONSOLIDATED_AMOUNT = 'CONSOLIDATED_AMOUNT',
  CONSOLIDATED_PERCENT = 'CONSOLIDATED_PERCENT',
}
